import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76e1c4a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bead-root" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "43",
  height: "43",
  viewBox: "0 0 43 43"
}
const _hoisted_3 = {
  id: "Group_42",
  "data-name": "Group 42",
  transform: "translate(-13 -749)"
}
const _hoisted_4 = ["fill"]
const _hoisted_5 = {
  key: 0,
  id: "Ellipse_27",
  "data-name": "Ellipse 27",
  transform: "translate(13 749)",
  fill: "#ff3d3d",
  stroke: "#fff",
  "stroke-width": "2"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "6.5",
  stroke: "none"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "5.5",
  fill: "none"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  id: "Ellipse_28",
  "data-name": "Ellipse 28",
  transform: "translate(43 779)",
  fill: "#2945ff",
  stroke: "#fff",
  "stroke-width": "2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "6.5",
  stroke: "none"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "6.5",
  cy: "6.5",
  r: "5.5",
  fill: "none"
}, null, -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  id: "闲",
  fill: "#fff",
  "font-size": "23",
  x: "50%",
  y: "50%",
  "dominant-baseline": "middle",
  "text-anchor": "middle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("g", _hoisted_3, [
        _createElementVNode("circle", {
          id: "Ellipse_26",
          "data-name": "Ellipse 26",
          cx: "21.5",
          cy: "21.5",
          r: "21.5",
          transform: "translate(13 749)",
          fill: _ctx.fillColor
        }, null, 8, _hoisted_4),
        (_ctx.hasRedpair)
          ? (_openBlock(), _createElementBlock("g", _hoisted_5, _hoisted_8))
          : _createCommentVNode("", true),
        (_ctx.hasBluePair)
          ? (_openBlock(), _createElementBlock("g", _hoisted_9, _hoisted_12))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("text", _hoisted_13, _toDisplayString(_ctx.label), 1)
    ]))
  ]))
}